//IDOGAN;436653;21022025
const panelFields = [
  { name: "isolationbactname", label: "Üreyen Bakteri", type: "text", editable: false },
  { name: "isolationtypereasonname", label: "İzolasyona Alınma Sebebi", type: "text", editable: false },
  { name: "isolation_taken_descrption", label: "İzolasyona Alınma Açıklaması", type: "text", editable: true },
  { name: "isolationtypewithoutbacname", label: "Bakteri Dışı İzol. Nedeni", type: "text", editable: false },
  { name: "notification_lab", label: "Mikrobiyoloji Ekibine", type: "checkbox" },
  { name: "notification_kitchen", label: "Mutfak Ekibine", type: "checkbox" },
  { name: "notification_cleaner", label: "Temizlik Ekibine", type: "checkbox" },
  { name: "is_given_family_education", label: "Hasta ve Ailesine", type: "checkbox" },
  { name: "app_user", label: "İşlem Yapan", type: "text", editable: false },
  { name: "start_date", label: "Başlangıç Tarihi", type: "date", editable: false },
  { name: "finish_date", label: "Bitiş Tarihi", type: "date", editable: false },
];

export default panelFields;
